import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('outdoor', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    fill: props.colors[1],
    fillRule: "nonzero",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-3.38652717e-14 38 14 6 24 30 28 18 40 38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "33",
    cy: "5",
    r: "5"
  }))));
});